'use client'

import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {useSimpleQuery} from '@frnt/base/hooks'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'
import qs from 'qs'

const ApiClientsServiceContext = createContext(undefined)

const ApiClientsServiceProvider = ({
  children,
  oauthApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={ApiClientsServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={oauthApiHost}
      valueCallback={(axios) => ({
        create: async (payload) => {
          const {data} = await axios.post(`/api_clients`, payload)
          return data
        },
        list: async (query) => {
          const {data} = await axios.get(
            `/api_clients${qs.stringify(query, {
              addQueryPrefix: true
            })}`
          )
          return data
        },
        get: async (id) => {
          const {data} = await axios.get(`/api_clients/${id}`)
          return data
        },
        update: async (id, payload) => {
          const {data} = await axios.patch(`/api_clients/${id}`, payload)
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

ApiClientsServiceProvider.propTypes = {
  children: PropTypes.any,
  oauthApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const useApiClientsService = () => {
  const context = useContext(ApiClientsServiceContext)
  if (context === undefined) {
    throw new Error('ApiClientsServiceContext was not provided. Make sure your component is a child of the ApiClientsServiceProvider.')
  }
  return context
}

const useApiClientsQuery = ({query, ...otherProps}) => {
  const apiClientsService = useApiClientsService()
  return useSimpleQuery({
    queryKey: `api_clients-list-${JSON.stringify(query)}`,
    queryFn: async () => apiClientsService.list(query),
    ...otherProps
  })
}

const useApiClientQuery = ({id, enabled, ...otherProps}) => {
  const apiClientsService = useApiClientsService()
  return useSimpleQuery({
    queryKey: `api_clients-get-${id}`,
    queryFn: async () => apiClientsService.get(id),
    enabled: enabled !== undefined ? enabled : !!id,
    ...otherProps
  })
}

export {ApiClientsServiceProvider, useApiClientsService, useApiClientsQuery, useApiClientQuery}
